import Vue from 'vue'
import * as api from '../api/mailTemplateApi'

const state = Vue.observable({
  templates: [],
  types: [],
  currentTemplate: null,
  meta: {},
  loading: false,
  previewHtml: '',
})

export function useMailTemplateStore() {
  return {
    // State (reactive)
    get templates() { return state.templates },
    get types() { return state.types },
    get currentTemplate() { return state.currentTemplate },
    get meta() { return state.meta },
    get loading() { return state.loading },
    get previewHtml() { return state.previewHtml },

    // --- Types ---

    async listTypes(holderType, holderId) {
      state.loading = true
      try {
        var result = await api.listTypes(holderType, holderId)
        state.types = Array.isArray(result) ? result : []
        return state.types
      } finally {
        state.loading = false
      }
    },

    // --- Templates ---

    async listTemplates(holderType, holderId, params) {
      if (params === undefined) params = {}
      state.loading = true
      try {
        var result = await api.listTemplates(holderType, holderId, params)
        state.templates = result.data ?? []
        state.meta = result.meta ?? {}
        return result
      } finally {
        state.loading = false
      }
    },

    async getTemplate(holderType, holderId, templateId) {
      state.loading = true
      try {
        var result = await api.getTemplate(holderType, holderId, templateId)
        state.currentTemplate = result
        return result
      } finally {
        state.loading = false
      }
    },

    async createTemplate(holderType, holderId, data) {
      state.loading = true
      try {
        var result = await api.createTemplate(holderType, holderId, data)
        state.currentTemplate = result
        return result
      } finally {
        state.loading = false
      }
    },

    async updateTemplate(holderType, holderId, templateId, data) {
      state.loading = true
      try {
        var result = await api.updateTemplate(holderType, holderId, templateId, data)
        state.currentTemplate = result
        return result
      } finally {
        state.loading = false
      }
    },

    async deleteTemplate(holderType, holderId, templateId) {
      return api.deleteTemplate(holderType, holderId, templateId)
    },

    async previewTemplate(holderType, holderId, data) {
      state.loading = true
      try {
        var result = await api.previewTemplate(holderType, holderId, data)
        state.previewHtml = (result && result.html) ? result.html : ''
        return result
      } finally {
        state.loading = false
      }
    },

    resetCurrent() {
      state.currentTemplate = null
      state.previewHtml = ''
    },
  }
}
